import { createSlice } from "@reduxjs/toolkit";
import config from "../../config";
import axios from "axios";

const BlogListSlice = createSlice({
  name: "BlogList",

  initialState: {
    blogListData: [],
    isLoading: true,
    isError: false,
  },

  reducers: {
    fetchBlogListStart: (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    fetchBlogListSuccess: (state, action) => {
      state.isLoading = false;
      state.blogListData = action.payload;
    },
    fetchBlogListFailure: (state, action) => {
      state.isLoading = false;
      state.isError = action.payload;
    },
  },
});

export const {
  fetchBlogListStart,
  fetchBlogListSuccess,
  fetchBlogListFailure,
} = BlogListSlice.actions;

export const fetchBlogList = () => async (dispatch, getState) => {
  const { BlogList } = getState();
  if (BlogList.blogListData.length > 0) {
    return;
  }
  dispatch(fetchBlogListStart());

  try {
    const response = await axios.get(`${config.apiUrl}/blog`);
    dispatch(fetchBlogListSuccess(response.data.data || response.data.blog_list || []));
  } catch (error) {
    dispatch(fetchBlogListFailure(error));
  }
};

export default BlogListSlice.reducer;
